function toParagraph(text: string) {
  const lines = text.split('\n');
  let result = '';
  for (const line of lines) {
    result += `<p>${line}</p>`;
  }
  return result;
}

const slideOne = {
      title: 'View One',
      image: 'assets/img/slide-1.png',
      thumb: 'assets/img/slide-1.png',
      hotspots: [
        {
          title: 'Fusion MD Models with Backlit Headers',
          number: 1,
          coordinates: {
            top: '50%',
            left: '28%'
          },
          link: 'https://structuralconcepts.com/products/?show=md',
          linkTitle: 'View Products',
          content: toParagraph('The spacious Fusion MD fresh food merchandiser delivers unmatched merchandising capacity, ideal for high-traffic environments where reduced refill frequency is key. The cases feature illuminated, backlit header graphics that elevate brand visibility and draw attention to featured fresh offerings. Its self-service, open reach-in design promotes easy access to an expansive variety of products, while an optional doored version adds flexibility for environments that require added temperature control or customization.'),
          images: ['https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD685R_DR4484-AIRPORT-ENV-2.png', 'https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD685R-EDU-CAF-07-26-2023.png', 'https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R_Hilton_Unit-1.jpg', 'https://djnnwndagrfti.cloudfront.net/resources/MD485DR-MD685DR/MD685DR_Education_Web.png']
        },
        {
          title: 'Heated Self Service Case',
          number: 2,
          coordinates: {
            top: '60%',
            left: '38%'
          },
          link: 'https://structuralconcepts.com/products/b2432h-b3632h',
          linkTitle: 'View Products',
          content: toParagraph('Expand your hot food program with a heated self-service case designed to merchandise convenient, ready-to-eat favorites like rotisserie chicken, hot sandwiches, and other grab-and-go meals. This display keeps products at proper holding temperatures while providing clear visibility and easy customer access, helping operators increase menu variety, improve speed of service, and capture on-the-go customers looking for warm, satisfying meal options.'),
          images: ['https://structuralconcepts.com/resources/download/1553'],
        },
        {
          title: 'myDesignPro Product Configurator',
          number: 3,
          coordinates: {
            top: '39%',
            left: '47%'
          },
          link: 'https://structuralconcepts.com/mydesignpro',
          linkTitle: 'Learn About myDesignPro',
          content: toParagraph('Multi-platform 3D product configurator that visually demonstrates how equipment will look and line up. Add features and modify options, such as how the case will appear in an actual line-up, determine shelving or other accessories, include a specific exterior or interior finish, and bring in any other available option. See results fast and export them as PDF, Revit or AutoCAD.'),
          videos: ['E4dqTGHWWyE']
        },
        {
          title: 'Reveal Service Cases',
          number: 4,
          coordinates: {
            top: '57%',
            left: '59%'
          },
          link: 'https://structuralconcepts.com/resources/view/13089',
          linkTitle: 'Learn About the Reveal Collection',
          content: toParagraph('Highlight your menu with Reveal Service Cases, designed to showcase hot, cold, and ready‑to‑serve items with uncompromising visibility and style. Frameless glass, clean lines, and brilliant LED lighting keep the focus on the food, while flexible configurations support a variety of restaurant needs—from hot entrées and fresh sandwiches to chilled salads and beverages. Choose heated, refrigerated, or combination service options to optimize your space and deliver a seamless guest experience in any foodservice environment.'),
          videos: ['QkRUl4rpILc']
        },
        {
          title: 'Refrigerated Self-Service Case — 26" Deep',
          number: 5,
          coordinates: {
            top: '53%',
            left: '70%'
          },
          link: 'https://structuralconcepts.com/products/bn37r-bn47r-bn57r',
          linkTitle: 'View Product',
          content: toParagraph('Designed for tight spaces without sacrificing capacity, this 26"-deep refrigerated self-service case is perfect for grab-and-go offerings or chilled prep ingredients such as salads, toppings, and fresh components. Its slim footprint simplifies installation in busy restaurant environments, while open, easy-access shelving keeps ingredients and ready-to-serve items visible, organized, and within quick reach for both guests and staff.'),
          images: ['https://djnnwndagrfti.cloudfront.net/resources/BN37R-BN47R-BN57R/B6624-133637091.jpg','https://djnnwndagrfti.cloudfront.net/resources/BN37R-BN47R-BN57R/B4524-3463.jpg','https://djnnwndagrfti.cloudfront.net/resources/BN37R-BN47R-BN57R/HEALTHCARE-BN37R-08-11-2024.png', ],
        },
      ]
};

const slideTwo = {
    title: 'View Two',
    image: 'assets/img/slide-2.png',
    thumb: 'assets/img/slide-2.png',
    hotspots: [
      {
        title: 'Fusion MD Models with Backlit Headers',
        number: 1,
        coordinates: {
          top: '59%',
          left: '44%'
        },
        link: 'https://structuralconcepts.com/products/?show=md',
        linkTitle: 'View Products',
        content: toParagraph('The spacious Fusion MD fresh food merchandiser delivers unmatched merchandising capacity, ideal for high-traffic environments where reduced refill frequency is key. The cases feature illuminated, backlit header graphics that elevate brand visibility and draw attention to featured fresh offerings. Its self-service, open reach-in design promotes easy access to an expansive variety of products, while an optional doored version adds flexibility for environments that require added temperature control or customization.'),
        images: ['https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD685R_DR4484-AIRPORT-ENV-2.png', 'https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD685R-EDU-CAF-07-26-2023.png', 'https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R_Hilton_Unit-1.jpg', 'https://djnnwndagrfti.cloudfront.net/resources/MD485DR-MD685DR/MD685DR_Education_Web.png']
      },
      {
        title: 'Heated Self Service Case',
        number: 2,
        coordinates: {
          top: '58%',
          left: '56%'
        },
        link: 'https://structuralconcepts.com/products/b2432h-b3632h',
        linkTitle: 'View Products',
        content: toParagraph('Expand your hot food program with a heated self-service case designed to merchandise convenient, ready-to-eat favorites like rotisserie chicken, hot sandwiches, and other grab-and-go meals. This display keeps products at proper holding temperatures while providing clear visibility and easy customer access, helping operators increase menu variety, improve speed of service, and capture on-the-go customers looking for warm, satisfying meal options.'),
        images: ['https://structuralconcepts.com/resources/download/1553'],
      },
      {
        title: 'Reveal Service Cases',
        number: 4,
        coordinates: {
          top: '49%',
          left: '63%'
        },
        link: 'https://structuralconcepts.com/resources/view/13089',
        linkTitle: 'Learn About the Reveal Collection',
        content: toParagraph('Highlight your menu with Reveal Service Cases, designed to showcase hot, cold, and ready‑to‑serve items with uncompromising visibility and style. Frameless glass, clean lines, and brilliant LED lighting keep the focus on the food, while flexible configurations support a variety of restaurant needs—from hot entrées and fresh sandwiches to chilled salads and beverages. Choose heated, refrigerated, or combination service options to optimize your space and deliver a seamless guest experience in any foodservice environment.'),
        videos: ['QkRUl4rpILc']
      },
      {
        title: 'Refrigerated Self-Service Case — 26" Deep',
        number: 5,
        coordinates: {
          top: '41%',
          left: '72%'
        },
        link: 'https://structuralconcepts.com/products/bn37r-bn47r-bn57r',
        linkTitle: 'View Product',
        content: toParagraph('Designed for tight spaces without sacrificing capacity, this 26"-deep refrigerated self-service case is perfect for grab-and-go offerings or chilled prep ingredients such as salads, toppings, and fresh components. Its slim footprint simplifies installation in busy restaurant environments, while open, easy-access shelving keeps ingredients and ready-to-serve items visible, organized, and within quick reach for both guests and staff.'),
        images: ['https://djnnwndagrfti.cloudfront.net/resources/BN37R-BN47R-BN57R/B6624-133637091.jpg','https://djnnwndagrfti.cloudfront.net/resources/BN37R-BN47R-BN57R/B4524-3463.jpg','https://djnnwndagrfti.cloudfront.net/resources/BN37R-BN47R-BN57R/HEALTHCARE-BN37R-08-11-2024.png', ],
      },
    ]
};

const slideThree = {
  title: 'View Three',
  image: 'assets/img/slide-3.png',
  thumb: 'assets/img/slide-3.png',
  hotspots: [
    {
      title: 'Fusion MD Models with Backlit Headers',
      number: 1,
      coordinates: {
        top: '53%',
        left: '65%'
      },
      link: 'https://structuralconcepts.com/products/?show=md',
      linkTitle: 'View Products',
      content: toParagraph('The spacious Fusion MD fresh food merchandiser delivers unmatched merchandising capacity, ideal for high-traffic environments where reduced refill frequency is key. The cases feature illuminated, backlit header graphics that elevate brand visibility and draw attention to featured fresh offerings. Its self-service, open reach-in design promotes easy access to an expansive variety of products, while an optional doored version adds flexibility for environments that require added temperature control or customization.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD685R_DR4484-AIRPORT-ENV-2.png', 'https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD685R-EDU-CAF-07-26-2023.png', 'https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R_Hilton_Unit-1.jpg', 'https://djnnwndagrfti.cloudfront.net/resources/MD485DR-MD685DR/MD685DR_Education_Web.png']
    },
    {
      title: 'Refrigerated & Heated Self-Service Case',
      number: 6,
      coordinates: {
        top: '62%',
        left: '57%'
      },
      link: 'https://structuralconcepts.com/products/b5024rh',
      linkTitle: 'View Product',
      content: toParagraph('New larger size heated and refrigerated self-service case provides a vertical combination of both hot and cold temperatures allowing foodservice operators to expand their offering in a single space, maximize impulse purchases, and elevate the customer experience.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/B5024RH/B5024RH_Web_Environment-1.png'],
      videos: ['OGNA7aob3T0']
    },
    {
      title: 'Autonomous Retail Merchandiser (ARM)',
      number: 7,
      coordinates: {
        top: '55%',
        left: '33%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'View Product',
      content: toParagraph('Structural Concepts is the only refrigerated manufacturer to design and manufacture a complete smart solution for autonomous shopping.<br><br>Offsetting labor challenges, an appealing refrigerated or ambient merchandising format with increased capacity, a cashier-less transactional system, and the ability to streamline inventory management, this single solution provides a quick payback turning into increased profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/BD3632-IS-ARM-DUO/BD3632IS-DUO-OFFICE-ENV-02-03-2026.png', 'https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0505-copy.jpg', 'https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0538-copy.jpg'],
      videos: ['rDBN2lb8SsI']
    },
  ]
};

const slideFour = {
  title: 'View Four',
  image: 'assets/img/slide-4.png',
  thumb: 'assets/img/slide-4.png',
  hotspots: [
    {
      title: 'Refrigerated & Heated Self-Service Case',
      number: 6,
      coordinates: {
        top: '52%',
        left: '73%'
      },
      link: 'https://structuralconcepts.com/products/b5024rh',
      linkTitle: 'View Product',
      content: toParagraph('New larger size heated and refrigerated self-service case provides a vertical combination of both hot and cold temperatures allowing foodservice operators to expand their offering in a single space, maximize impulse purchases, and elevate the customer experience.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/B5024RH/B5024RH_Web_Environment-1.png'],
      videos: ['OGNA7aob3T0']
    },
    {
      title: 'Autonomous Retail Merchandiser (ARM)',
      number: 7,
      coordinates: {
        top: '62%',
        left: '52%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'View Product',
      content: toParagraph('Structural Concepts is the only refrigerated manufacturer to design and manufacture a complete smart solution for autonomous shopping.<br><br>Offsetting labor challenges, an appealing refrigerated or ambient merchandising format with increased capacity, a cashier-less transactional system, and the ability to streamline inventory management, this single solution provides a quick payback turning into increased profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/BD3632-IS-ARM-DUO/BD3632IS-DUO-OFFICE-ENV-02-03-2026.png', 'https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0505-copy.jpg', 'https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0538-copy.jpg'],
      videos: ['rDBN2lb8SsI']
    },
    {
      title: 'FreshWatch',
      number: 8,
      coordinates: {
        top: '44%',
        left: '56%'
      },
      link: 'https://youtu.be/EzBs2f1soKw',
      linkTitle: 'Learn More About FreshWatch',
      content: toParagraph('An advanced, cloud-based solution providing real-time monitoring and remote diagnostics that ensures food safety, reduces waste, and improves operational efficiency. With proactive alerts and detailed insights on equipment performance, operators can minimize downtime, lower costs, and boost profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/FreshWatch-Logo.png']
    },
    {
      title: 'Self-Service Case Lineup Featuring Clean Sweep™ Technology',
      number: 9,
      coordinates: {
        top: '45%',
        left: '23%'
      },
      link: 'https://youtu.be/gTgsz5KIZtU',
      linkTitle: 'Learn About Clean Sweep',
      content: toParagraph('Streamline your grab-and-go program with a full range of self-service solutions—from compact C33R-UC under-counter refrigeration to sleek, frameless-glass refrigerated <a href="https://structuralconcepts.com/products/ne3627rssv-ne4827rssv-ne6027rssv-ne7227rssv" target="_blank">NE3627RSSV</a> and heated <a href="https://structuralconcepts.com/products/ne3627hssv-ne4827hssv" target="_blank">NE3627HSSV</a> slide-in counter cases. The <a href="https://structuralconcepts.com/products/ne3627rssv-ne4827rssv-ne6027rssv-ne7227rssv" target="_blank"> NE3627RSSV</a> features our award-winning Clean Sweep® Technology, an automated brush system that removes dust and debris from the condenser coil daily to prevent clogs and maintain peak performance with less manual maintenance. For hot offerings, the heated models deliver reliable service, while the <a href="https://structuralconcepts.com/products/csc3223" target="_blank">CSC3223</a> completes the lineup as a simple, non-refrigerated countertop case ideal for displaying pastries and baked goods. Together, these solutions create a cohesive, efficient, and customer-friendly self-service experience.'),
    },
    {
      title: 'Refrigerated Self-Service Case — 34" Deep',
      number: 10,
      coordinates: {
        top: '33%',
        left: '38%'
      },
      link: 'https://structuralconcepts.com/products/b35r-b45r-b55r-b65r',
      linkTitle: 'View Product',
      content: toParagraph('This 34"-deep refrigerated self-service case offers a spacious, low-profile solution for showcasing grab-and-go items in busy restaurant environments. Designed to maintain foods at a dependable 40°F, it provides open, easy access that encourages quick selection and boosts impulse purchases. With its wide display area and inviting visibility, it’s ideal for chilled menu items, packaged snacks, and ready-to-serve offerings.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/CO35R-CO45R-CO55R-CO65R/CO45R-101054202.jpg']
    },
  ]
};

const slideFive = {
  title: 'View Five',
  image: 'assets/img/slide-5.png',
  thumb: 'assets/img/slide-5.png',
  hotspots: [
    {
      title: 'Autonomous Retail Merchandiser (ARM)',
      number: 7,
      coordinates: {
        top: '52%',
        left: '76%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'View Product',
      content: toParagraph('Structural Concepts is the only refrigerated manufacturer to design and manufacture a complete smart solution for autonomous shopping.<br><br>Offsetting labor challenges, an appealing refrigerated or ambient merchandising format with increased capacity, a cashier-less transactional system, and the ability to streamline inventory management, this single solution provides a quick payback turning into increased profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/BD3632-IS-ARM-DUO/BD3632IS-DUO-OFFICE-ENV-02-03-2026.png', 'https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0505-copy.jpg', 'https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0538-copy.jpg'],
      videos: ['rDBN2lb8SsI']
    },
    {
      title: 'FreshWatch',
      number: 8,
      coordinates: {
        top: '45%',
        left: '59%'
      },
      link: 'https://youtu.be/EzBs2f1soKw',
      linkTitle: 'Learn More About FreshWatch',
      content: toParagraph('An advanced, cloud-based solution providing real-time monitoring and remote diagnostics that ensures food safety, reduces waste, and improves operational efficiency. With proactive alerts and detailed insights on equipment performance, operators can minimize downtime, lower costs, and boost profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/FreshWatch-Logo.png']
    },
    {
      title: 'Self-Service Case Lineup Featuring Clean Sweep™ Technology',
      number: 9,
      coordinates: {
        top: '57%',
        left: '39%'
      },
      link: 'https://youtu.be/gTgsz5KIZtU',
      linkTitle: 'Learn About Clean Sweep',
      content: toParagraph('Streamline your grab-and-go program with a full range of self-service solutions—from compact C33R-UC under-counter refrigeration to sleek, frameless-glass refrigerated <a href="https://structuralconcepts.com/products/ne3627rssv-ne4827rssv-ne6027rssv-ne7227rssv" target="_blank">NE3627RSSV</a> and heated <a href="https://structuralconcepts.com/products/ne3627hssv-ne4827hssv" target="_blank">NE3627HSSV</a> slide-in counter cases. The <a href="https://structuralconcepts.com/products/ne3627rssv-ne4827rssv-ne6027rssv-ne7227rssv" target="_blank"> NE3627RSSV</a> features our award-winning Clean Sweep® Technology, an automated brush system that removes dust and debris from the condenser coil daily to prevent clogs and maintain peak performance with less manual maintenance. For hot offerings, the heated models deliver reliable service, while the <a href="https://structuralconcepts.com/products/csc3223" target="_blank">CSC3223</a> completes the lineup as a simple, non-refrigerated countertop case ideal for displaying pastries and baked goods. Together, these solutions create a cohesive, efficient, and customer-friendly self-service experience.'),
    },
    {
      title: 'Refrigerated Self-Service Case — 34" Deep',
      number: 10,
      coordinates: {
        top: '45%',
        left: '29%'
      },
      link: 'https://structuralconcepts.com/products/b35r-b45r-b55r-b65r',
      linkTitle: 'View Product',
      content: toParagraph('This 34"-deep refrigerated self-service case offers a spacious, low-profile solution for showcasing grab-and-go items in busy restaurant environments. Designed to maintain foods at a dependable 40°F, it provides open, easy access that encourages quick selection and boosts impulse purchases. With its wide display area and inviting visibility, it’s ideal for chilled menu items, packaged snacks, and ready-to-serve offerings.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/CO35R-CO45R-CO55R-CO65R/CO45R-101054202.jpg']
    },
  ]
};

const slideSix = {
  title: 'View Six',
  image: 'assets/img/slide-6.png',
  thumb: 'assets/img/slide-6.png',
  hotspots: [
    {
      title: 'Autonomous Retail Merchandiser (ARM)',
      number: 7,
      coordinates: {
        top: '37%',
        left: '75%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'View Product',
      content: toParagraph('Structural Concepts is the only refrigerated manufacturer to design and manufacture a complete smart solution for autonomous shopping.<br><br>Offsetting labor challenges, an appealing refrigerated or ambient merchandising format with increased capacity, a cashier-less transactional system, and the ability to streamline inventory management, this single solution provides a quick payback turning into increased profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/BD3632-IS-ARM-DUO/BD3632IS-DUO-OFFICE-ENV-02-03-2026.png', 'https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0505-copy.jpg', 'https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/BD3632IS_DEK_0538-copy.jpg'],
      videos: ['rDBN2lb8SsI']
    },
    {
      title: 'FreshWatch',
      number: 8,
      coordinates: {
        top: '39%',
        left: '55%'
      },
      link: 'https://youtu.be/EzBs2f1soKw',
      linkTitle: 'Learn More About FreshWatch',
      content: toParagraph('An advanced, cloud-based solution providing real-time monitoring and remote diagnostics that ensures food safety, reduces waste, and improves operational efficiency. With proactive alerts and detailed insights on equipment performance, operators can minimize downtime, lower costs, and boost profitability.'),
      images: ['https://djnnwndagrfti.cloudfront.net/content/nra/FreshWatch-Logo.png']
    },
    {
      title: 'Self-Service Case Lineup Featuring Clean Sweep™ Technology',
      number: 9,
      coordinates: {
        top: '65%',
        left: '52%'
      },
      link: 'https://youtu.be/gTgsz5KIZtU',
      linkTitle: 'Learn About Clean Sweep',
      content: toParagraph('Streamline your grab-and-go program with a full range of self-service solutions—from compact C33R-UC under-counter refrigeration to sleek, frameless-glass refrigerated <a href="https://structuralconcepts.com/products/ne3627rssv-ne4827rssv-ne6027rssv-ne7227rssv" target="_blank">NE3627RSSV</a> and heated <a href="https://structuralconcepts.com/products/ne3627hssv-ne4827hssv" target="_blank">NE3627HSSV</a> slide-in counter cases. The <a href="https://structuralconcepts.com/products/ne3627rssv-ne4827rssv-ne6027rssv-ne7227rssv" target="_blank"> NE3627RSSV</a> features our award-winning Clean Sweep® Technology, an automated brush system that removes dust and debris from the condenser coil daily to prevent clogs and maintain peak performance with less manual maintenance. For hot offerings, the heated models deliver reliable service, while the <a href="https://structuralconcepts.com/products/csc3223" target="_blank">CSC3223</a> completes the lineup as a simple, non-refrigerated countertop case ideal for displaying pastries and baked goods. Together, these solutions create a cohesive, efficient, and customer-friendly self-service experience.'),
    },
    {
      title: 'Refrigerated Self-Service Case — 34" Deep',
      number: 10,
      coordinates: {
        top: '58%',
        left: '34%'
      },
      link: 'https://structuralconcepts.com/products/b35r-b45r-b55r-b65r',
      linkTitle: 'View Product',
      content: toParagraph('This 34"-deep refrigerated self-service case offers a spacious, low-profile solution for showcasing grab-and-go items in busy restaurant environments. Designed to maintain foods at a dependable 40°F, it provides open, easy access that encourages quick selection and boosts impulse purchases. With its wide display area and inviting visibility, it’s ideal for chilled menu items, packaged snacks, and ready-to-serve offerings.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/CO35R-CO45R-CO55R-CO65R/CO45R-101054202.jpg']
    },
    {
      title: 'The Hoshizaki Alliance',
      number: 11,
      coordinates: {
        top: '42%',
        left: '67%'
      },
      link: 'https://hoshizakialliance.com/',
      linkTitle: 'Learn More About the Alliance',
      content: toParagraph('We are proud to be part of the Hoshizaki Alliance—a collective of industry-leading manufacturing companies operating independently under one enterprise, united by a shared commitment to delivering trusted, high-performing solutions that help customers grow their business. The Alliance brings together a deep and innovative portfolio of front- and back-of-house equipment, including Hoshizaki ice machines, Jackson warewashing systems, Lancer beverage dispensers, Fogel commercial refrigeration, Macom kitchen equipment, and our own Structural Concepts heated and refrigerated displays and merchandisers.<br><br>While each company brings its own category-leading expertise, the strength of the Alliance lies in the connectivity and alignment across brands—ensuring a consistently high standard of excellence for every customer segment we serve.<br><br>Be sure to visit their booth # 6207 to learn more about how the Hoshizaki Alliance is shaping the future of foodservice'),
      images: ['assets/img/hoshizaki.png']
    },
  ]
};

const slideSeven = {
  title: 'View Seven',
  image: 'assets/img/slide-7.png',
  thumb: 'assets/img/slide-7.png',
  hotspots: [
    {
      title: 'The Hoshizaki Alliance',
      number: 11,
      coordinates: {
        top: '30%',
        left: '62%'
      },
      link: 'https://hoshizakialliance.com/',
      linkTitle: 'Learn More About the Alliance',
      content: toParagraph('We are proud to be part of the Hoshizaki Alliance—a collective of industry-leading manufacturing companies operating independently under one enterprise, united by a shared commitment to delivering trusted, high-performing solutions that help customers grow their business. The Alliance brings together a deep and innovative portfolio of front- and back-of-house equipment, including Hoshizaki ice machines, Jackson warewashing systems, Lancer beverage dispensers, Fogel commercial refrigeration, Macom kitchen equipment, and our own Structural Concepts heated and refrigerated displays and merchandisers.<br><br>While each company brings its own category-leading expertise, the strength of the Alliance lies in the connectivity and alignment across brands—ensuring a consistently high standard of excellence for every customer segment we serve.<br><br>Be sure to visit their booth # 6207 to learn more about how the Hoshizaki Alliance is shaping the future of foodservice'),
      images: ['assets/img/hoshizaki.png']
    },
  ]
};

const slideEight = {
  title: 'View Eight',
  image: 'assets/img/slide-8.png',
  thumb: 'assets/img/slide-8.png',
  hotspots: [
    {
      title: 'Heated Self Service Case',
      number: 2,
      coordinates: {
        top: '39%',
        left: '30%'
      },
      link: 'https://structuralconcepts.com/products/b2432h-b3632h',
      linkTitle: 'View Products',
      content: toParagraph('Expand your hot food program with a heated self-service case designed to merchandise convenient, ready-to-eat favorites like rotisserie chicken, hot sandwiches, and other grab-and-go meals. This display keeps products at proper holding temperatures while providing clear visibility and easy customer access, helping operators increase menu variety, improve speed of service, and capture on-the-go customers looking for warm, satisfying meal options.'),
      images: ['https://structuralconcepts.com/resources/download/1553'],
    },
    {
      title: 'The Hoshizaki Alliance',
      number: 11,
      coordinates: {
        top: '27%',
        left: '49%'
      },
      link: 'https://hoshizakialliance.com/',
      linkTitle: 'Learn More About the Alliance',
      content: toParagraph('We are proud to be part of the Hoshizaki Alliance—a collective of industry-leading manufacturing companies operating independently under one enterprise, united by a shared commitment to delivering trusted, high-performing solutions that help customers grow their business. The Alliance brings together a deep and innovative portfolio of front- and back-of-house equipment, including Hoshizaki ice machines, Jackson warewashing systems, Lancer beverage dispensers, Fogel commercial refrigeration, Macom kitchen equipment, and our own Structural Concepts heated and refrigerated displays and merchandisers.<br><br>While each company brings its own category-leading expertise, the strength of the Alliance lies in the connectivity and alignment across brands—ensuring a consistently high standard of excellence for every customer segment we serve.<br><br>Be sure to visit their booth # 6207 to learn more about how the Hoshizaki Alliance is shaping the future of foodservice'),
      images: ['assets/img/hoshizaki.png']
    },
  ]
};

const slides = [
  slideOne,
  slideTwo,
  slideThree,
  slideFour,
  slideFive,
  slideSix,
  slideSeven,
  slideEight,
];


export const slideData = slides.map((slide, parentIndex) => ({
  ...slide,
  hotspots: slide.hotspots.map(hotspot => ({
    ...hotspot,
    parentIndex
  }))
}));
